import React, { Component } from 'react';
import { CURRENCY, FORMAT_NUMBER, json, Modules, priceDecimalPrecision, SERVICE_RESPONSE, Sections } from '../../../libs/utils/Const';
import { ToolTip } from '../..';
import { formatNumber, isMarketingDocument, isMarketingDocumentSAP } from '../../../libs/utils/GlobalFunc';
import config from '../../../config';
import '../../../css/responsive.css';
import Select from 'react-select';
import ApiClient from '../../../libs/apiClient';
const apiClient = ApiClient.getInstance();
class PaymentHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            docTypeList: [],
            seriesPuerta: [],
            seriesPlanta: [],
            correlatives:[],
        }
    }
    componentDidMount() {
        this.loadDocType();
        this.openSeriesLLG();
    }

    loadDocType = async () => {
        const { props } = this.props
        const { enableSpinner } = props
        enableSpinner(true);
        const apiResponse = await apiClient.listDocTypeSeries();
        enableSpinner(false);
        if (apiResponse.status === SERVICE_RESPONSE.SUCCESS) {
            let docTypeList = apiResponse?.data ?? []
            docTypeList = docTypeList ? docTypeList.map(op => ({
                value: op.Code,
                label: `${op.Code} - ${op.U_BPP_TDDD}`
            })) : [];
            this.setState({
                docTypeList
            })
        }
    }
    changeDocType = event => {
        const { props } = this.props
        const { refreshModel, newOrderModel } = props
        let value = ''
        if (event && event.value !== undefined) {
            value = event.value;
        } else if (event && event.nativeEvent && event.nativeEvent.target) {
            value = event.nativeEvent.target.value;
        }
        newOrderModel.U_BPP_MDTD = value
        newOrderModel.U_BPP_PTSC = null
        newOrderModel.U_BPP_PTCC = null
        refreshModel(newOrderModel);
    }
    changeSerieCert = event => {
        const { props } = this.props
        const { refreshModel, newOrderModel } = props
        let value = ''
        if (event && event.value !== undefined) {
            value = event.value;
        } else if (event && event.nativeEvent && event.nativeEvent.target) {
            value = event.nativeEvent.target.value;
        }
        newOrderModel.U_BPP_PTSC = value
        newOrderModel.U_BPP_PTCC = null
        refreshModel(newOrderModel);

    }

    changeCorrelativoCert = event => {
        const { props } = this.props
        const { refreshModel, newOrderModel } = props
        let value = ''
        if (event && event.value !== undefined) {
            value = event.value;
        } else if (event && event.nativeEvent && event.nativeEvent.target) {
            value = event.nativeEvent.target.value;
        }
        newOrderModel.U_BPP_PTCC = value
        refreshModel(newOrderModel);
    }
    parseSeries = (data) => {
        if (!data || typeof data !== 'object') return [];

        const result = [];
        for (const key in data) {
            const value = data[key];
            if (typeof value !== 'string') continue;

            const parts = value.split('|').filter(Boolean);
            for (const part of parts) {
                const [code, flag] = part.split('~');
                const exists = result.some(
                    item => item.value === key && item.label === (code || '-1')
                );
                if (!exists) {

                    result.push({
                        key,
                        code: code || '',
                        isDefault: flag === 'D',
                        value: `${key}-${code || (result.length + 1)}`,
                        label: code || '',

                    });

                }
            }
        }
        return result;
    }
    openSeriesLLG() {
        const { state } = this.props
        const { _user } = state ?? {}
        let serPuertaObj = JSON.stringify(_user?.U_FMB_ValidateSeriesPUERTA);
        let serPlantaObj = JSON.stringify(_user?.U_FMB_ValidateSeriesSUNAT);
        let seriesPuerta = {}
        let seriesPlanta = {}
        try {
            seriesPuerta = JSON.parse(serPuertaObj && serPuertaObj.trim() !== "" ? serPuertaObj : "{}");
        } catch (e) {
            seriesPuerta = {};
        }
        try {
            seriesPlanta = JSON.parse(serPlantaObj && serPlantaObj.trim() !== "" ? serPlantaObj : "{}");
        } catch (e) {
            seriesPlanta = {};
        }
        seriesPuerta = this.parseSeries(seriesPuerta)
        seriesPlanta = this.parseSeries(seriesPlanta)
        this.setState({
            seriesPuerta, seriesPlanta
        })
    }



    render() {
        const { type } = this.props;
        return (
            <>
                {type === 'HEAD' ? (
                    this.PaymentHeader()
                ) : (
                    <></>
                )}
            </>
        );
    }

    PaymentHeader = () => {
        const {
            props
            , state
            , openProjects
            , openPartner
            , changeCardCode
            , changeAddress
            , openPersonContact
            , openConfirmCurrency
            , openCurrency
            , openCuentaMayor
            , selectTrsfrDate
            , changeTransfersRef
            , changeTrsfrSum
            , validateTrsfrSumNull
            , openCheckList
            , changeCashSumEnter
            , changeCashSum
            , validateCashSumNull
            , selectTabCard
            , addCreditCard
            , openCard
            , validateCardNum
            , changeCardNum
            , changeCardValid
            , ChangeValidateValidCard
            , changeOwnerIdNum
            , changeOwnerPhone
            , keydownHandler
            , changeCreditSum
            , changeVoucherNum
            , changeCreditType
            , changeCreditSumOne
            , openSeries
            , selectDocDate
            , selectDocDueDate
            , changeCounterRef
            , changeCFW
        } = this.props
        const { action, newOrderModel, seriesDoc } = props;
        let { CFWOptions = [] } = props;
        const { editMode } = state;
        const { docTypeList, seriesPlanta,correlatives } = this.state
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let stp = user ? user.U_FMBEnviar_STP : '';
        let socio = 'Cliente';

        if (newOrderModel.OriginDocumentCreate === 'outgoingPayment') {
            socio = 'Proveedor';
        }
        const isAccountPayment = newOrderModel?.isAccountPayment;
        const tipoDoc = newOrderModel?.U_BPP_MDTD ?? null
        const serieDoc =  newOrderModel?.U_BPP_PTSC ?? null
        const filteredOptions = tipoDoc
            ? (seriesPlanta ?? []).filter(opt =>
                opt.value?.startsWith(`${tipoDoc}-`)
            )
            : [];

        const mapCFWOptions = (options = []) =>
            options.map(cfw => ({
                value: cfw.CFWId,
                label: `${cfw.CFWId} - ${cfw.CFWName}`
            }));

        const transferCFWOptions = !Sections['FlujoCaja'] ? [] : mapCFWOptions(action === 2 ? newOrderModel?.transferCFWOptions ?? [] : CFWOptions);
        const cashCFWOptions = !Sections['FlujoCaja'] ? [] : mapCFWOptions(action === 2 ? newOrderModel?.cashCFWOptions ?? [] : CFWOptions);
        const checkCFWOptions = !Sections['FlujoCaja'] ? [] : mapCFWOptions(action === 2 ? newOrderModel?.checkCFWOptions ?? [] : CFWOptions);

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    {isAccountPayment ?
                        <>
                            {/*Proyecto*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Proyecto</span>
                                </div>
                                <input
                                    type=" text"
                                    className="form-control"
                                    id="txtProject"
                                    disabled="true"
                                    value={newOrderModel?.PrjCode || ''}
                                />
                                {/* {(action === 1 || (action == 2 && editMode)) && ( */}
                                {action === 1 && (
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={openProjects}>
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                )}
                            </div>
                        </>
                        :
                        <>
                            {/*No del cliente*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">{socio}</span>
                                </div>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtPartner"
                                    style={{
                                        backgroundColor: newOrderModel.partnerSelected ? 'rgb(248,242,209)' : 'transparent',
                                    }}
                                    disabled={action === 2 && !editMode ? true : false}
                                    onKeyPress={(ev) => {
                                        if (ev.key === 'Enter') {
                                            openPartner();
                                        }
                                    }}
                                    onChange={changeCardCode}
                                    value={newOrderModel.CardCode ? newOrderModel.CardCode : ''}
                                />
                                {action == 1 && (
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={openPartner}>
                                        <i className="fas fa-user" />
                                    </button>
                                )}
                            </div>
                            {/*Nombre del cliente*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                                </div>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtName"
                                    disabled="true"
                                    value={newOrderModel.CardName ? newOrderModel.CardName : ''}
                                />
                            </div>
                            {/*Address:*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Dirección</span>
                                </div>
                                <input
                                    type=" text"
                                    className="form-control"
                                    id="txtCustomerRefNo"
                                    disabled={(action == 2 && !editMode) ? true : false}
                                    value={newOrderModel.Address ? newOrderModel.Address : ''}
                                    onChange={changeAddress}
                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                />
                            </div>
                            {/*Persona de Contacto*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Contacto</span>
                                </div>
                                <input
                                    type=" text"
                                    className="form-control"
                                    id="txtContactPerson"
                                    disabled="true"
                                    value={newOrderModel.CntctName ? newOrderModel.CntctName : ''}
                                />
                                {(action == 1 || (action == 2 && editMode)) && (
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={openPersonContact}>
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                )}
                            </div>
                        </>
                    }

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Moneda</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtLocalCurrency"
                            disabled={true}
                            value={newOrderModel.DocCur ? newOrderModel.DocCur : ''}
                        />
                        {(action == 1 || (action == 2 && editMode && !isAccountPayment)) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={isAccountPayment ? openConfirmCurrency : openCurrency}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                        {/*<button type="button" style={{backgroundColor: "transparent", color: "#EABF28"}} className="btn"
                                        onClick={this.openMonedaLocal}>
                                    <i className="fa fa-list" aria-hidden="true"></i>
                                </button>*/}
                    </div>

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Cambio</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtLocalCurrency"
                            disabled={true}
                            value={newOrderModel.ChangeRate ? Number(newOrderModel.ChangeRate).toFixed(2) : 1}
                        />
                    </div>

                    {/*PAGOS*/}
                    <div className="tab-content" id="myTabContent" style={{ textAlign: 'left' }}>
                        <div
                            className="tab-pane fade show active "
                            id="transfersControl"
                            role="tabpanel"
                            aria-labelledby="nav-home-tab-One"><br></br>
                            <div className="card col-12 bodyCar" style={{ background: 'transparent' }}>
                                <div className="card-body bodyCar">
                                    <h5 className="card-title" style={{ color: '#EABF28' }}>Datos Transferencia:</h5>

                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">Cuenta a mayor</span>
                                                <span className="d-inline d-xl-none">Cta. mayor</span>
                                            </span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            id="txtName"
                                            disabled="true"
                                            value={newOrderModel.TrsfrAcctFormatCode ? newOrderModel.TrsfrAcctFormatCode : ''}
                                        />
                                        {action === 1 && (
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                className="input-group-text"
                                                onClick={() => openCuentaMayor(0, 2)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        )}
                                    </div>
                                    {/*Fecha de contabilización:*/}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">F. Transferencia</span>
                                                <span className="d-inline d-xl-none">F. Transfer.</span>
                                            </span>
                                        </div>
                                        <input
                                            id="txtPostingDate"
                                            style={{
                                                width: '100%',
                                                important: true,
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                            }}
                                            className="form-control  btn-outline-secondary"
                                            type={action === 2 ? 'date' : 'date'}
                                            disabled={action === 2 ? true : false}
                                            placeholder="Fecha min"
                                            autoComplete="off"
                                            value={newOrderModel.TrsfrDate ? newOrderModel.TrsfrDate : ''}
                                            onChange={selectTrsfrDate}
                                        />
                                    </div>
                                    {/*numero dde referenca tarsnferrencia*/}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Referencia</span>
                                        </div>
                                        <input
                                            type=" text"
                                            className="form-control btn-outline-secondary"
                                            disabled={action === 2 ? true : false}
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                            }}
                                            value={newOrderModel.TrsfrRef ? newOrderModel.TrsfrRef : ''}
                                            onChange={changeTransfersRef}
                                        />
                                    </div>
                                    {/*total en trasferencia*/}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Total</span>
                                        </div>
                                        <input
                                            type=" text"
                                            className="form-control btn-outline-secondary"
                                            disabled={action === 2 ? true : false}
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                                textAlign: "right",
                                            }}
                                            value={action === 2 ? Number(newOrderModel.TrsfrSum).toFixed(2) : newOrderModel.TrsfrSum}
                                            onChange={changeTrsfrSum}
                                            onBlur={validateTrsfrSumNull}
                                        />
                                    </div>
                                    {/* Flujo de caja */}
                                    {Sections['FlujoCaja'] &&
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Flujo de caja</span>
                                            </div>
                                            {(
                                                <Select
                                                    options={transferCFWOptions}
                                                    value={transferCFWOptions?.find(opt => opt.value === newOrderModel.transferCFWId) || null}
                                                    onChange={(event) => action !== 2 && changeCFW(event, 1)}
                                                    placeholder={action === 2 ? '' : "Escribe para buscar"}
                                                    isDisabled={action === 2 || !newOrderModel.needTransferCFW}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    menuPortalTarget={document.body}
                                                    noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                    styles={{
                                                        container: (base) => ({ ...base, flex: 1 }),
                                                        control: (base) => ({ ...base, height: 40, minHeight: 40, minWidth: 300, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                        input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                        singleValue: (base) => ({ ...base, color: "#000" })
                                                    }}
                                                />
                                            )}
                                        </div>
                                    }
                                </div>
                            </div>

                        </div>
                        <div
                            className="tab-pane fade"
                            id="chequeControl"
                            role="tabpanel"
                            aria-labelledby="nav-profile-tab-C"><br></br>
                            <div className="card col-12 bodyCar" style={{ background: 'transparent' }}>
                                <div className="card-body bodyCar">
                                    <h5 className="card-title" style={{ color: '#EABF28' }}>Datos Cheque:</h5>
                                    {/*Cuenta mayor*/}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">Cuenta a mayor</span>
                                                <span className="d-inline d-xl-none">Cta. mayor</span>
                                            </span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            id="txtName"
                                            disabled="true"
                                            value={newOrderModel.CheckAcctFormatCode ? newOrderModel.CheckAcctFormatCode : ''}
                                        />
                                        {action === 1 && (
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                className="input-group-text"
                                                onClick={() => openCuentaMayor(0, 3)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        )}
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">Lista cheques</span>
                                                <span className="d-inline d-xl-none">Cheques</span>
                                            </span>
                                        </div>
                                        <button
                                            type="button"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                            className="btn"
                                            onClick={openCheckList}>
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>
                                    </div>

                                    {/* Flujo de caja */}
                                    {(Sections['FlujoCaja'] && false) &&
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Flujo de caja</span>
                                            </div>
                                            {(
                                                <Select
                                                    options={checkCFWOptions}
                                                    value={checkCFWOptions?.find(opt => opt.value === newOrderModel.checkCFWId) || null}
                                                    onChange={(event) => action !== 2 && changeCFW(event, 3)}
                                                    placeholder={action === 2 ? '' : "Escribe para buscar"}
                                                    isDisabled={action === 2 || !newOrderModel.needCheckCFW}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    menuPortalTarget={document.body}
                                                    noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                    styles={{
                                                        container: (base) => ({ ...base, flex: 1 }),
                                                        control: (base) => ({ ...base, height: 40, minHeight: 40, minWidth: 300, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                        input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                        singleValue: (base) => ({ ...base, color: "#000" })
                                                    }}
                                                />
                                            )}
                                        </div>
                                    }
                                </div>

                            </div>
                        </div>
                        <br></br>

                        <div
                            className="tab-pane fade"
                            id="cashControl"
                            role="tabpanel"
                            aria-labelledby="nav-contact-tab-E"><br></br>
                            <div className="card col-12 bodyCar" style={{ background: 'transparent' }}>
                                <div className="card-body bodyCar">
                                    <h5 className="card-title" style={{ color: '#EABF28' }}>Datos Efectivo:</h5>
                                    {/*Cuenta mayor*/}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                <span className="d-none d-xl-inline">Cuenta a mayor</span>
                                                <span className="d-inline d-xl-none">Cta. mayor</span>
                                            </span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            id="txtName"
                                            disabled="true"
                                            value={newOrderModel.CashAcctFormatCode ? newOrderModel.CashAcctFormatCode : ''}
                                        />
                                        {action === 1 && (
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                className="input-group-text"
                                                onClick={() => openCuentaMayor(0, 4)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        )}
                                    </div>
                                    {/*total en cash*/}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Total</span>
                                        </div>
                                        <input
                                            type=" text"
                                            className="form-control btn-outline-secondary"
                                            disabled={action === 2 ? true : false}
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                                textAlign: "right",
                                            }}
                                            value={action === 2 ? Number(newOrderModel.CashSum).toFixed(2) : newOrderModel.CashSum}
                                            onKeyPress={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    changeCashSumEnter()
                                                }
                                            }}
                                            onChange={changeCashSum}
                                            onBlur={validateCashSumNull}
                                        />
                                    </div>
                                    {/* Flujo de caja */}
                                    {Sections['FlujoCaja'] &&
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Flujo de caja</span>
                                            </div>
                                            {(
                                                <Select
                                                    options={cashCFWOptions}
                                                    value={cashCFWOptions?.find(opt => opt.value === newOrderModel.cashCFWId) || null}
                                                    onChange={(event) => action !== 2 && changeCFW(event, 2)}
                                                    placeholder={action === 2 ? '' : "Escribe para buscar"}
                                                    isDisabled={action === 2 || !newOrderModel.needCashCFW}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    menuPortalTarget={document.body}
                                                    noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                    styles={{
                                                        container: (base) => ({ ...base, flex: 1 }),
                                                        control: (base) => ({ ...base, height: 40, minHeight: 40, minWidth: 300, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                        input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                        singleValue: (base) => ({ ...base, color: "#000" })
                                                    }}
                                                />
                                            )}
                                        </div>
                                    }
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="cardControl"
                            role="tabpanel"
                            aria-labelledby="nav-contac-tab-T">
                            <div className="card col-12 bodyCar" style={{ background: 'transparent' }}>
                                <div className="card-body bodyCar">
                                    <h5 className="card-title" style={{ color: '#EABF28' }}>Datos de Tarjeta</h5>
                                    <div>
                                        <div className="nav nav-tabs" id="myTabCards" role="tablist">
                                            {!!newOrderModel.PaymentsCreditCards && newOrderModel.PaymentsCreditCards.map((card, index) => {
                                                return (
                                                    <>
                                                        <span
                                                            className={`nav-item nav-link${card.isSelected ? " active" : ""}`}
                                                            id={`card${index}-tab`}
                                                            data-bs-toggle="tab"
                                                            data-bs-target={`#card${index}`}
                                                            role="tab"
                                                            aria-controls={`card${index}`}
                                                            aria-selected={`${card.isSelected ? "true" : "false"}`}
                                                            onClick={() => selectTabCard(index)}>
                                                            {card.CardName || `Tarjeta ${index + 1} `}
                                                            <i className="fa fa-times" style={{ marginLeft: 7 }} aria-hidden="true" onClick={() => this.deleteCard(index)} />
                                                        </span>
                                                    </>
                                                )
                                            })}

                                            {(Number(action) === 1 || (Number(action) === 2 && editMode)) &&
                                                <li className="nav-item" role="presentation">
                                                    <button
                                                        className="nav-link"
                                                        id={`addCard-tab`}
                                                        data-bs-toggle="tab"
                                                        data-bs-target={`#addCard`}
                                                        type="button"
                                                        role="tab"
                                                        aria-controls={`addCard`}
                                                        aria-selected="false"
                                                        onClick={addCreditCard}>
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                    </button>
                                                </li>
                                            }
                                        </div>

                                        <div className="tab-content" id="myTabContentCard" style={{ textAlign: 'left' }}>
                                            {!!newOrderModel.PaymentsCreditCards &&
                                                newOrderModel.PaymentsCreditCards.map((card, index) => {
                                                    return (
                                                        <div
                                                            className={`tab-pane fade${card.isSelected ? " show active" : ""}`}
                                                            id={`card${index}`}
                                                            role="tabpanel"
                                                            aria-labelledby={`card${index}-tab`}>

                                                            {/* Nombre de tarjeta */}
                                                            <div className="input-group mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                        <span className="d-none d-xl-inline">Nombre de tarjeta</span>
                                                                        <span className="d-inline d-xl-none">Nombre Tarjeta</span>
                                                                    </span>
                                                                </div>
                                                                <input
                                                                    type="text"
                                                                    className="form-control input-sm"
                                                                    id="txtCardName"
                                                                    disabled="true"
                                                                    value={card.CardName || ''}
                                                                />

                                                                {action === 1 && (
                                                                    <button
                                                                        type="button"
                                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                                        className="input-group-text"
                                                                        onClick={() => openCard(index)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                )}
                                                            </div>

                                                            {/*Cuenta de Mayor*/}
                                                            <div className="input-group mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                        <span className="d-none d-xl-inline">Cuenta de Mayor</span>
                                                                        <span className="d-inline d-xl-none">Cuenta Mayor</span>
                                                                    </span>
                                                                </div>
                                                                <input
                                                                    type="text"
                                                                    className="form-control input-sm"
                                                                    id="txtName"
                                                                    disabled="true"
                                                                    value={card.CreditAcct || ''}
                                                                />

                                                                {action === 1 && (
                                                                    <button
                                                                        type="button"
                                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                                        className="input-group-text"
                                                                        onClick={() => openCuentaMayor(0, 8)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                )}
                                                            </div>

                                                            {/*Numero de tarjeta*/}
                                                            <div className="input-group mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                        <span className="d-none d-xl-inline">Número de tarjeta</span>
                                                                        <span className="d-inline d-xl-none">Número tarjeta</span>
                                                                    </span>
                                                                </div>
                                                                <input
                                                                    type={action === 2 ? "password" : "text"}
                                                                    className="form-control btn-outline-secondary"
                                                                    disabled={action === 2 ? true : false}
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    maxlength="4"
                                                                    value={card.CrCardNum || ''}
                                                                    onBlur={(event) => validateCardNum(event.nativeEvent.target.value, index)}
                                                                    onChange={(event) => changeCardNum(event.nativeEvent.target.value, index)}
                                                                />
                                                            </div>

                                                            {/*Válido hasta*/}
                                                            <div className="input-group mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Válido hasta</span>
                                                                </div>
                                                                <input
                                                                    type=" text"
                                                                    className="form-control btn-outline-secondary"
                                                                    disabled={action === 2 ? true : false}
                                                                    placeholder='MM/AA'
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    maxlength="5"
                                                                    value={card.CardValid || ''}
                                                                    onChange={(event) => changeCardValid(event.nativeEvent.target.value, index)}
                                                                    onBlur={(event) => ChangeValidateValidCard(event.nativeEvent.target.value, index)}
                                                                />
                                                            </div>

                                                            {/*Número de ID*/}
                                                            <div className="input-group mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                        <span className="d-none d-xl-inline">Número de ID</span>
                                                                        <span className="d-inline d-xl-none">Núm ID</span>
                                                                    </span>
                                                                </div>
                                                                <input
                                                                    type=" text"
                                                                    className="form-control btn-outline-secondary"
                                                                    disabled={action === 2 ? true : false}
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    maxlength="15"
                                                                    value={card.OwnerIdNum || ''}
                                                                    onChange={(event) => changeOwnerIdNum(event.nativeEvent.target.value, index)}
                                                                />
                                                            </div>

                                                            {/*Número de teléfono*/}
                                                            <div className="input-group mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                        <span className="d-none d-xl-inline">Número de teléfono</span>
                                                                        <span className="d-inline d-xl-none">Teléfono</span>
                                                                    </span>
                                                                </div>
                                                                <input
                                                                    type=" text"
                                                                    className="form-control btn-outline-secondary"
                                                                    disabled={action === 2 ? true : false}
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    maxlength="20"
                                                                    value={card.OwnerPhone || ''}
                                                                    onChange={(event) => changeOwnerPhone(event.nativeEvent.target.value, index)}
                                                                />
                                                            </div>

                                                            {/*Forma de pago*/}
                                                            <div className="input-group mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                        <span className="d-none d-xl-inline">Forma de pago</span>
                                                                        <span className="d-inline d-xl-none">Forma Pago</span>
                                                                    </span>
                                                                </div>
                                                                <input
                                                                    type=" text"
                                                                    className="form-control btn-outline-secondary"
                                                                    disabled={action === 2 ? true : false}
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    value={card.CrTypeCode || ''}
                                                                />
                                                            </div>

                                                            {/*Importe vencido*/}
                                                            <div className="input-group mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                        <span className="d-none d-xl-inline">Importe vencido</span>
                                                                        <span className="d-inline d-xl-none">Importe Vencido</span>
                                                                    </span>
                                                                </div>
                                                                <input
                                                                    type=" text"
                                                                    className="form-control btn-outline-secondary"
                                                                    disabled={action === 2 ? true : false}
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    maxlength="40"
                                                                    value={action === 2 ? Number(card.CreditSum).toFixed(2) : card.CreditSum}
                                                                    onKeyPress={(event) => keydownHandler(event, index)}
                                                                    onChange={(event) => changeCreditSum(event.nativeEvent.target.value, index)}
                                                                />
                                                            </div>

                                                            {/* Primer pago parcial
                                                                    <div className="input-group mb-3">
                                                                        <div class="input-group-prepend">
                                                                            <span class="input-group-text font-weight-bold" id="basic-addon1">Primer pago parcial</span>
                                                                        </div>
                                                                            <input
                                                                                type=" text"
                                                                                className="form-control btn-outline-secondary"
                                                                                disabled={action === 2 ? true : false}
                                                                                style={{
                                                                                    backgroundColor: 'transparent',
                                                                                    borderColor: '#ced4da',
                                                                                    color: '#000',
                                                                                }}
                                                                                value={newOrderModel.TrsfrRef ? newOrderModel.TrsfrRef : ''}
                                                                                onChange={changeTransfersRef}
                                                                            />
                                                                    </div> */}

                                                            {/*Cada pago adicional*/}
                                                            {/* <div className="input-group mb-3">
                                                                        <div class="input-group-prepend">
                                                                            <span class="input-group-text font-weight-bold" id="basic-addon1">Cada pago adicional</span>
                                                                        </div>
                                                                            <input
                                                                                type=" text"
                                                                                className="form-control btn-outline-secondary"
                                                                                disabled={action === 2 ? true : false}
                                                                                style={{
                                                                                    backgroundColor: 'transparent',
                                                                                    borderColor: '#ced4da',
                                                                                    color: '#000',
                                                                                }}
                                                                                value={newOrderModel.TrsfrRef ? newOrderModel.TrsfrRef : ''}
                                                                                onChange={changeTransfersRef}
                                                                            />
                                                                    </div> */}

                                                            {/*N° certific.retenc.impto*/}
                                                            <div className="input-group mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                        <span className="d-none d-xl-inline">N° certific.retenc.impto</span>
                                                                        <span className="d-inline d-xl-none">N° Certificado</span>
                                                                    </span>
                                                                </div>
                                                                <input
                                                                    type=" text"
                                                                    className="form-control btn-outline-secondary"
                                                                    disabled={action === 2 ? true : false}
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    maxlength="20"
                                                                    value={card.VoucherNum || ''}
                                                                    onChange={(event) => changeVoucherNum(event.nativeEvent.target.value, index)}
                                                                />
                                                            </div>

                                                            {/*Clase de operación*/}
                                                            <div className="input-group mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                        <span className="d-none d-xl-inline">Clase de operación</span>
                                                                        <span className="d-inline d-xl-none">Clase Operación</span>
                                                                    </span>
                                                                </div>
                                                                <select className="form-control"
                                                                    onChange={event => changeCreditType(event.nativeEvent.target.value, index)}
                                                                    value={card.CreditType}>
                                                                    <option value="S">Regular</option>
                                                                    <option value="I">Transacción de Internet</option>
                                                                    <option value="U">Transacción telefónica</option>
                                                                </select>
                                                            </div>

                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>

                                        {/*total en trasferencia*/}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Total</span>
                                            </div>
                                            <input
                                                type=" text"
                                                className="form-control btn-outline-secondary"
                                                disabled={true}
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    borderColor: '#ced4da',
                                                    color: '#000',
                                                    textAlign: "right",
                                                }}
                                                value={Number(newOrderModel.CreditSum).toFixed(2)}
                                                onChange={changeCreditSumOne}
                                            />
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                </div>
                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    {/*No Serie*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtDocumentDate"
                            disabled="true"
                            value={newOrderModel.SerieName ? newOrderModel.SerieName : ''}
                        />
                        {action == 1 && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={openSeries}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                    {/*N°:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtNo"
                            disabled="true"
                            value={newOrderModel.NextFolio ? newOrderModel.NextFolio : ''}
                        />
                    </div>
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">F. Contabilización</span>
                                <span className="d-inline d-xl-none">F. Contab.</span>
                            </span>
                        </div>
                        <input
                            id="txtPostingDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control"
                            type={action == 2 ? 'date' : 'date'}
                            disabled={action == 2 ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.DocDate ? newOrderModel.DocDate : ''}
                            onChange={selectDocDate}
                        />
                    </div>
                    {/*Fecha de entrega:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">F. Vencimiento</span>
                                <span className="d-inline d-xl-none">F. Venc.</span>
                            </span>
                        </div>
                        <input
                            id="txtDeliverDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control"
                            type={action == 2 && !editMode ? 'date' : 'date'}
                            disabled={action == 2 && !editMode ? true : false}
                            placeholder="Fecha min"
                            autoComplete="off"
                            value={newOrderModel.DocDueDate ? newOrderModel.DocDueDate : ''}
                            onChange={selectDocDueDate}
                        />
                    </div>
                    {/*>Fecha de documento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Documento</span>
                        </div>
                        <input
                            type="date"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control"
                            id="txtStatus"
                            max='9999-12-31'
                            autoComplete="off"
                            disabled="true"
                            value={newOrderModel.TaxDate ? newOrderModel.TaxDate : ''}
                        />
                    </div>
                    {/*>Referencia:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Referencia</span>
                        </div>
                        <input
                            type=" text"
                            disabled={(action == 2 && !editMode) ? true : false}
                            className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="txtDocument"
                            value={newOrderModel.CounterRef ? newOrderModel.CounterRef : ''}
                            onChange={changeCounterRef}
                        />
                    </div>
                    {/*>No.Operacion:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">No. Operación</span>
                                <span className="d-inline d-xl-none">No. Oper.</span>
                            </span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtNo"
                            disabled="true"
                            value={newOrderModel.TransId ? newOrderModel.TransId : ''}
                        />
                    </div>

                    {/*Tipo de Documento*/}
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de Documento</span>
                        </div>
                        <Select
                            menuPlacement="auto"
                            options={docTypeList}
                            value={docTypeList.find(acct => acct.value === newOrderModel.U_BPP_MDTD) || null}
                            onChange={this.changeDocType}
                            placeholder="Buscar..."
                            isDisabled={!(action == 1)}
                            isSearchable
                            isClearable
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1 }),
                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                singleValue: (base) => ({ ...base, color: "#000" })
                            }}
                        />
                    </div> */}

                    {/*Serie del certificado*/}
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Serie del Certificado</span>
                        </div>
                        <Select
                            menuPlacement="auto"
                            options={filteredOptions}
                            value={filteredOptions.find(acct => acct.value === newOrderModel.U_BPP_PTSC) || null}
                            onChange={this.changeSerieCert}
                            placeholder="Buscar..."
                            isDisabled={!(action == 1 && tipoDoc) || !(action == 1)}
                            isSearchable
                            isClearable
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1 }),
                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                singleValue: (base) => ({ ...base, color: "#000" })
                            }}
                        />
                    </div> */}

                    {/*Correlativo del certificado*/}
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Correlativo del Certificado</span>
                        </div>
                        <input
                            type=" text"
                            className="form-control"
                            id="txtNo"
                            disabled={!(action == 1 && tipoDoc && serieDoc) || !(action == 1)}
                            value={newOrderModel.U_BPP_PTCC ? newOrderModel.U_BPP_PTCC : ''}
                            onChange={this.changeCorrelativoCert}
                        />
                    </div> */}


                </div>
            </div>
        );
    }
}

export default PaymentHeader;
